import React from "react";
import { Button } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const QuantitySelector = ({ value, max, min = 0, onChange }) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        icon={<MinusOutlined />}
        disabled={value <= min}
        onClick={() => onChange(value - 1)}
      />
      <span className="w-6 text-center">{value}</span>
      <Button
        icon={<PlusOutlined />}
        disabled={value >= max}
        onClick={() => onChange(value + 1)}
      />
    </div>
  );
};

export default QuantitySelector;
